// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-MainFrame-Header-Bell-Bell-module__bell--Jpdjy {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  justify-content: center;
}
.src-components-MainFrame-Header-Bell-Bell-module__bell--Jpdjy > button {
  padding: 0;
  display: flex;
  align-items: center;
}
.src-components-MainFrame-Header-Bell-Bell-module__icon--tDwpi svg {
  color: blue;
}
.src-components-MainFrame-Header-Bell-Bell-module__icon--tDwpi:hover svg {
  color: green;
}
.src-components-MainFrame-Header-Bell-Bell-module__icon--tDwpi.src-components-MainFrame-Header-Bell-Bell-module__error--J_YGd svg {
  color: red;
}
.src-components-MainFrame-Header-Bell-Bell-module__bellActive--P9252 {
  background-color: white;
}
.src-components-MainFrame-Header-Bell-Bell-module__bellActive--P9252 .src-components-MainFrame-Header-Bell-Bell-module__icon--tDwpi svg {
  color: black;
}
.src-components-MainFrame-Header-Bell-Bell-module__bellActive--P9252 .src-components-MainFrame-Header-Bell-Bell-module__icon--tDwpi:hover svg {
  color: black;
}
.src-components-MainFrame-Header-Bell-Bell-module__bellActive--P9252 .src-components-MainFrame-Header-Bell-Bell-module__badge--bcWYF .ant-badge-count {
  color: white;
  background-color: red !important;
  box-shadow: 0 0 0 2px white !important;
}
.src-components-MainFrame-Header-Bell-Bell-module__spin--V1IKA {
  width: 15px;
  height: 15px;
}
.src-components-MainFrame-Header-Bell-Bell-module__badge--bcWYF .ant-badge-count {
  background-color: red !important;
  font-size: 9px;
  font-weight: 800;
  padding: 0;
  width: 16px;
  min-width: 16px;
  height: 16px;
  line-height: 16px;
  top: 1.5px;
  left: 1.5px;
}
.src-components-MainFrame-Header-Bell-Bell-module__badge--bcWYF.src-components-MainFrame-Header-Bell-Bell-module__badgeSmallText--Je7wY .ant-badge-count {
  font-size: 7px;
}
.src-components-MainFrame-Header-Bell-Bell-module__bellButton--gXb95 {
  margin: 0;
  padding: 0;
  border: none;
  cursor: pointer;
  background-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/components/MainFrame/Header/Bell/Bell.module.less"],"names":[],"mappings":"AAOA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;AANF;AAOE;EACE,UAAA;EACA,aAAA;EACA,mBAAA;AALJ;AASA;EAEI,WAAA;AARJ;AAUE;EAEI,YAAA;AATN;AAYE;EAEI,UAAA;AAXN;AAeA;EACE,uBAAA;AAbF;AAYA;EAIM,YAAA;AAbN;AAeI;EAEI,YAAA;AAdR;AAmBI;EACE,YAAA;EACA,gCAAA;EACA,sCAAA;AAjBN;AAqBA;EACE,WAAA;EACA,YAAA;AAnBF;AAuBE;EACE,gCAAA;EAEA,cAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;AAtBJ;AAyBI;EACE,cAAA;AAvBN;AA2BA;EACE,SAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;AAzBF","sourcesContent":["// @import \"/src/variables.less\";\n\n@primary: white;\n@icon-color: blue;\n@icon-color-hover: green;\n@status-red: red;\n\n.bell {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  justify-content: center;\n  & > button {\n    padding: 0;\n    display: flex;\n    align-items: center;\n  }\n}\n\n.icon {\n  svg {\n    color: @icon-color;\n  }\n  &:hover {\n    svg {\n      color: @icon-color-hover;\n    }\n  }\n  &.error {\n    svg {\n      color: @status-red;\n    }\n  }\n}\n.bellActive {\n  background-color: @primary;\n  .icon {\n    svg {\n      color: black;\n    }\n    &:hover {\n      svg {\n        color: black;\n      }\n    }\n  }\n  .badge {\n    & :global(.ant-badge-count) {\n      color: @primary;\n      background-color: red !important;\n      box-shadow: 0 0 0 2px @primary !important;\n    }\n  }\n}\n.spin {\n  width: 15px;\n  height: 15px;\n}\n\n.badge {\n  & :global(.ant-badge-count) {\n    background-color: red !important;\n    // box-shadow: none !important;\n    font-size: 9px;\n    font-weight: 800;\n    padding: 0;\n    width: 16px;\n    min-width: 16px;\n    height: 16px;\n    line-height: 16px;\n    top: 1.5px;\n    left: 1.5px;\n  }\n  &.badgeSmallText {\n    & :global(.ant-badge-count) {\n      font-size: 7px;\n    }\n  }\n}\n.bellButton {\n  margin: 0;\n  padding: 0;\n  border: none;\n  cursor: pointer;\n  background-color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bell": `src-components-MainFrame-Header-Bell-Bell-module__bell--Jpdjy`,
	"icon": `src-components-MainFrame-Header-Bell-Bell-module__icon--tDwpi`,
	"error": `src-components-MainFrame-Header-Bell-Bell-module__error--J_YGd`,
	"bellActive": `src-components-MainFrame-Header-Bell-Bell-module__bellActive--P9252`,
	"badge": `src-components-MainFrame-Header-Bell-Bell-module__badge--bcWYF`,
	"spin": `src-components-MainFrame-Header-Bell-Bell-module__spin--V1IKA`,
	"badgeSmallText": `src-components-MainFrame-Header-Bell-Bell-module__badgeSmallText--Je7wY`,
	"bellButton": `src-components-MainFrame-Header-Bell-Bell-module__bellButton--gXb95`
};
export default ___CSS_LOADER_EXPORT___;
